<div class="trigger-wrap">
    <ion-button size="small" fill="outline" color="primary" (click)="onLinkExistingJob()">
        <fa-icon icon="layer-group" slot="start"></fa-icon>
        {{ 'projects.jobs.details.linking.parts.existing' | translate }}
        <ng-container *ngIf="!utils.isPhone">{{ 'projects.jobs.details.linking.parts.job' | translate }}</ng-container>
        {{ 'projects.jobs.details.linking.parts.link' | translate }}
    </ion-button>

    <ion-button size="small" fill="outline" color="primary" (click)="onLinkNewJob()">
        <fa-icon icon="layer-plus" slot="start"></fa-icon>
        {{ 'projects.jobs.details.linking.add-btn' | translate }}
    </ion-button>
</div>

<!-- START: DIALOG TO LINK AN EXISTING JOB -->
<ion-modal
    class="stack-modal"
    #linkExistingJobModal
    [isOpen]="linkExistingJobModalVisible"
    (didDismiss)="linkExistingJobModalVisible = false"
>
    <ng-template>
        <ion-header>
            <ion-toolbar>
                <ion-title>{{ 'projects.jobs.details.linking.title' | translate }}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-no-padding">
            <app-code-scanner
                class="dialog-scanner"
                [(isEnabled)]="scanEnabled"
                containerType="modal"
                [searchIcon]="'search'"
                [searchTextPlaceholder]="'projects.jobs.details.linking.scan-search.placeholder' | translate"
                (onScanCancel)="onCancelExistingJobLinkSearch()"
                (onScanResult)="onExistingJobLinkScanResult($event)"
            ></app-code-scanner>

            <app-loading-indicator *ngIf="jobLinkSearchResultsLoading">{{
                'projects.jobs.details.linking.scan-search.loading' | translate
            }}</app-loading-indicator>
            <ng-container *ngIf="!jobLinkSearchResultsLoading && lastJobLinkSearchString != ''">
                <div class="search-results ion-text-center dp-mt-s">
                    <h3>
                        {{
                            'projects.jobs.details.linking.scan-search.result-title' | translate: { searchString: lastJobLinkSearchString }
                        }}
                    </h3>
                    <ng-container *ngIf="jobLinkSearchResults.length > 0; else noSearchResults">
                        <ion-list>
                            <ion-item
                                detail
                                *ngFor="let searchResult of jobLinkSearchResults"
                                (click)="selectExistingJobForLinking(searchResult)"
                            >
                                <ion-label>{{ searchResult.jobNumber + ' - ' + searchResult.name }}</ion-label>
                                <ion-label slot="end">{{ searchResult.code }}</ion-label>
                            </ion-item>
                        </ion-list>
                    </ng-container>
                    <ng-template #noSearchResults>
                        <div class="dp-mt-m dp-mb-m">
                            <app-info-bar icon="magnifying-glass">{{
                                'projects.jobs.details.linking.scan-search.empty-result' | translate
                            }}</app-info-bar>
                        </div>
                        <div>
                            <ion-button fill="clear" color="warning" (click)="onCancelExistingJobLinkSearch()">{{
                                'shared.cancel' | translate
                            }}</ion-button>
                            <ion-button (click)="onRestartJobLinkSearch()">
                                <fa-icon icon="qrcode" slot="start"></fa-icon>
                                {{ 'projects.jobs.details.linking.scan-search.reset-btn' | translate }}
                            </ion-button>
                        </div>
                    </ng-template>
                </div>
            </ng-container>
        </ion-content>
    </ng-template>
</ion-modal>

<!-- START: DIALOG TO CREATE A NEW JOB (WHICH IS LINKED) -->
<ion-modal
    class="stack-modal"
    #createNewJobWithLinkingModal
    [isOpen]="newJobWithLinkingModalVisible"
    (didDismiss)="newJobWithLinkingModalVisible = false"
>
    <ng-template>
        <ion-header>
            <ion-toolbar>
                <ion-title>{{ 'projects.jobs.details.linking.new.title' | translate }}</ion-title>
            </ion-toolbar>
        </ion-header>
        <ion-content class="ion-no-padding">
            <app-loading-indicator *ngIf="workableServiceGroupsLoading">{{
                'projects.jobs.details.linking.new.actions-loading' | translate
            }}</app-loading-indicator>
            <ng-container *ngIf="workableServiceGroups.length > 0; else noWorkableServiceGroups">
                <p class="ion-text-center">
                    {{ 'projects.jobs.details.linking.new.sg-info' | translate }}
                </p>
                <ion-list>
                    <ion-item *ngFor="let serviceGroup of workableServiceGroups">
                        {{ serviceGroup.name }}
                        <ion-button slot="end" (click)="createNewJobWithLinking(serviceGroup)">
                            <fa-icon icon="plus" slot="start"></fa-icon>
                            {{ serviceGroup.defaultJobName }}
                        </ion-button>
                    </ion-item>
                </ion-list>
            </ng-container>
            <ng-template #noWorkableServiceGroups>
                <div class="dp-notice">
                    <div class="notice-header">
                        @if (allowedRelations.length > 0) {
                            <div class="notice-title">{{ 'projects.jobs.details.linking.no-sg-found-title' | translate }}</div>
                        } @else {
                            <div class="notice-title">{{ 'projects.jobs.details.linking.missing-permission-title' | translate }}</div>
                        }
                    </div>
                    <div class="notice-content">
                        @if (allowedRelations.length > 0) {
                            {{ 'projects.jobs.details.linking.no-sg-found-info' | translate }}
                        } @else {
                            {{ 'projects.jobs.details.linking.missing-permission-info' | translate }}
                        }
                    </div>
                </div>
            </ng-template>
        </ion-content>
        <ion-footer class="ion-text-end">
            <ion-button fill="clear" color="warning" (click)="onCancelNewJobLink()">{{ 'shared.cancel' | translate }}</ion-button>
        </ion-footer>
    </ng-template>
</ion-modal>
